var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value"},[_c('figure',{staticClass:"image-value"},[_vm._t("image"),_c('div',{staticClass:"circle"},[_c('p',[_vm._t("number")],2)])],2),_c('article',[_c('h4',[_vm._t("title")],2),_c('p',[_vm._t("text")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }